import React from 'react';

import Col from 'react-bootstrap/Col';
import InlineEditorWrapper from '../../utilities/InlineEditorWrapper';
import ListView from '../shared/lists/ListView';
import NameFranchiseEditor from '../shared/editors/NameFranchiseEditor';
import NameFranchiseItem from '../shared/editors/NameFranchiseItem';
import PagedListControl from '../shared/lists/PagedListControl';
import Row from 'react-bootstrap/Row';
import SortableTh from '../shared/table/SortableTh';
import useFilter from '../../utilities/useFilter';

const LookupView = (props) => {
    const getUrl = '/api/lookups/list';
    const postUrl = `/api/lookups/${props.lookupType}/edit`;
    const editUrl = `/api/lookups/${props.lookupType}/edit/`;
    const deleteUrl = `/api/lookups/${props.lookupType}/delete`;
    const nonFranchiseTypes = ['JobStatus', 'AreaType'];

    const { items, setData, submitFilter, pageInfo, canCreate } = useFilter(getUrl, { lookupType: props.lookupType }, true);

    const canAdd = canCreate === true ? items && items.filter(i => i.id === 0).length === 0 : false;

    function addNew() {
        const currentData = JSON.parse(JSON.stringify(items));
        if (canAdd) {
            currentData.push({ id: 0, name: '' });
            setData(currentData);
        }
    }

    const tableHead = (
        <thead className="table-index-head">
            <tr>
                <SortableTh sortName="Name" sort={pageInfo}>Name</SortableTh>
                {props.showExternal &&
                    <SortableTh width={100} content="External" sort={pageInfo} sortName="ExternallyVisible" />
                }
                <th className="two-button-cell">&nbsp;</th>
            </tr>
        </thead>
    );

    const lookUps = items.map((item) =>
        <InlineEditorWrapper
            editItem={props.editItem}
            isNew={item.id === 0}
            key={item.id}
        >
            <NameFranchiseItem
                deleteUrl={deleteUrl}
                fetchData={submitFilter}
                hideFranchise={nonFranchiseTypes.includes(props.lookupType)}
                showExternal={props.showExternal}
                item={item}
            />
            <NameFranchiseEditor
                cancelEdit={submitFilter}
                fetchData={submitFilter}
                getUrl={editUrl + item.id}
                hideFranchise={nonFranchiseTypes.includes(props.lookupType)}
                showExternal={props.showExternal}
                item={item}
                postUrl={postUrl}
            />
        </InlineEditorWrapper>
    );

    return (
        <Row>
            <Col>
                <ListView
                    addItem={addNew}
                    canAdd={canAdd}
                    itemName={props.title}
                    items={lookUps}
                    tableHead={tableHead}
                />
                <Row className="mt-4">
                    <Col>
                        <PagedListControl {...pageInfo} />
                    </Col>
                </Row>
            </Col>
        </Row>
    );
}

export default LookupView;